export const RESTART_ON_REMOUNT = "@@saga-injector/restart-on-remount";
export const DAEMON = "@@saga-injector/daemon";
export const ONCE_TILL_UNMOUNT = "@@saga-injector/once-till-unmount";

// localStorage Key
export const LOGIN_KEY = "gs_admin_user";

// logged in user keys
export const LOGIN_TOKEN = "accessToken";
export const LOGIN_USER_ID = "userId";
export const LOGIN_USERNAME = "username";
export const LOGIN_EXPIRES = "expires";

export const IMAGE_FILE_TYPE = "jpg,jpeg,png";
